import { http } from "./api";

const endpointBase = 'api/paises/';

export const getPaises = async () => {
    const url = endpointBase
    return http.get(url);
}
